import logger from "./logger";

class ImageStorage {
    constructor() {
        this.storage = {
            img: null,
            backImg: null
        };
    }

    async saveImage(key, base64Data) {
        try {
            this.storage[key] = base64Data;

            const sizeMB = (base64Data.length / (1024 * 1024)).toFixed(2);
            logger.log(`Image saved to memory: ${key} (${sizeMB}MB)`);

            return Promise.resolve();
        } catch (error) {
            logger.error('Error saving image:', error);
            throw error;
        }
    }

    async getImage(key) {
        try {
            const image = this.storage[key];
            if (!image) {
                logger.warn(`Image not found: ${key}`);
                return null;
            }
            return Promise.resolve(image);
        } catch (error) {
            logger.error('Error getting image:', error);
            return null;
        }
    }

    async deleteImage(key) {
        try {
            delete this.storage[key];
            logger.log(`Image deleted: ${key}`);
            return Promise.resolve();
        } catch (error) {
            logger.error('Error deleting image:', error);
            throw error;
        }
    }

    async clearAll() {
        try {
            this.storage = {
                img: null,
                backImg: null
            };
            logger.log('All images cleared from memory');
            return Promise.resolve();
        } catch (error) {
            logger.error('Error clearing images:', error);
            throw error;
        }
    }

    getMemorySize() {
        let size = 0;
        if (this.storage.img) size += this.storage.img.length;
        if (this.storage.backImg) size += this.storage.backImg.length;
        return size;
    }

    logMemoryUsage() {
        const size = this.getMemorySize();
        const sizeMB = (size / (1024 * 1024)).toFixed(2);
        logger.log(`Total memory usage: ${sizeMB}MB`);
    }
}

export const imageStorage = new ImageStorage();

